(function() {
  var $ = typeof Checkout !== "undefined" ? Checkout.jQuery : jQuery;

  var debug = true;

  var Cookies = window.ExitIntentPopupVendor.Cookies;
  var EventEmitter = window.ExitIntentPopupVendor.EventEmitter;

  var format_seconds = window.ExitIntentPopupVendor.format_seconds;
  var ga_load = window.ExitIntentPopupVendor.ga_load;
  var klaviyo_load = window.ExitIntentPopupVendor.klaviyo_load;
  var mobile = window.ExitIntentPopupVendor.mobile;

  function Email(events, module) {
    return {
      valid: function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    }
  };

  function Input(element, events, options, module) {
    $(element).on("change", function() {
      if( Email().valid(element.value) ) {
        events.trigger("input:change", [element.value]);

        // var inputs = element.querySelectorAll("[name='checkout[email_or_phone]'], [name='checkout[email]']");
        //
        // inputs.forEach(function(input) {
        //   input.value = element.value;
        // });
      }
    });
  };

  function Klaviyo(events, module) {
    events.on("input:change", identify);

    function identify(email) {
      _learnq.push(['identify', {
        '$email' : email
      }]);
    }
  }

  function Steps(element, events, options, module) {
    events.on("popup:show", show);
    events.on("popup:hide", hide);

    function show() {
      $(element).show();
    };

    function hide() {
      $(element)
        .addClass("is-minimising")
        .one("transitionend", function() {
          $(element)
            .hide()
            .removeClass("is-minimising");

          events.trigger("popup:hidetransitionend");
        });
    };
  };

  function Step(element, events, options, module) {
    events.on("popup:hidetransitionend", hide);

    $(element).on("click", function(event) {
      if( event.target == this ) {
        events.trigger("stepbackground:click");
      }
    });

    function show() {
      $(element).show();
    };

    function hide() {
      $(element).hide();
    };

    function enabled() {
      return (mobile() && options.mobile_enabled || !mobile() && options.enabled);
    }

    function handle_klaviyo_custom_event() {
      if (typeof _learnq !== "undefined" && options.klaviyo_event_enabled) {
        var data = {};
        if (options.klaviyo_event_data == "cart") {
          data = module.options.data.cart;
        }
        _learnq.push(['track', options.klaviyo_event_name, data]);
      }
    }

    return {
      show: show,
      hide: hide,
      enabled: enabled,
      handle_klaviyo_custom_event: handle_klaviyo_custom_event
    }
  };

  function Step1(element, events, options, module) {
    var step = Step(element, events, options, module);

    if (step.enabled()) {
      events.on("popup:show", step.show);
      events.on("popup:proceed", function() {
        step.hide();
        step.handle_klaviyo_custom_event();
      });
      events.on("popup:success", step.hide);
    } else {
      events.on("popup:proceed", step.hide);
      events.on("popup:success", step.hide);

      // TODO make this make more sense
      // "exitintent" is kind of hacked to be like an onInit method
      // I can't trigger popup:proceed outside of it, because by the time the script
      // gets to Step1, Step2 hasn't binded it's events yet.
      events.on("exitintent", function() {
        events.on("popup:show", function() {
          step.hide();
          events.trigger("popup:proceed");
        });
      });
    }
  };

  function Step2(element, events, options, module) {
    var step = Step(element, events, options, module);

    if (step.enabled()) {
      events.on("popup:show", step.hide);
      events.on("popup:proceed", step.show);
      events.on("popup:success", function() {
        step.hide();
        step.handle_klaviyo_custom_event();
      });
    } else {
      events.on("popup:show", step.hide);
      events.on("popup:success", step.hide);

      // TODO same as Step1 todo
      events.on("exitintent", function() {
        events.on("popup:proceed", function() {
          step.hide();
          events.trigger("popup:success");
        });
      });
    }
  };

  function Step3(element, events, options, module) {
    var step = Step(element, events, options, module);

    if (step.enabled()) {
      events.on("popup:show", step.hide);
      events.on("popup:proceed", step.hide);
      events.on("popup:success", step.show);
    } else {
      events.on("popup:show", step.hide);
      events.on("popup:proceed", step.hide);

      // TODO same as Step1 todo
      events.on("exitintent", function() {
        events.on("popup:success", function() {
          step.hide();
          // TODO do I need to trigger any other steps?
        });
      });
    }
  };

  function Banner(element, events, options, module) {
    var refs = {
      frame: element.querySelectorAll("[data-ref-frame]")
    };

    if( mobile() && options.mobile_banner || !mobile() && options.banner ) {
      $(element).addClass("is-banner");
    } else {
      return;
    }

    events.on("popup:show", show_placehold);
    events.on("popup:proceed", hide_placehold);
    events.on("popup:hide", hide_placehold);

    function show_placehold() {
      $("body").css({
        "padding-top": $(refs.frame).outerHeight()
      });
    };

    function hide_placehold() {
      $("body").css({
        "padding-top": ""
      });
    };
  };

  function ExitButton(element, events, options, module) {
    $(element).on("click", function() {
      events.trigger("exitbutton:click");
    });
  };

  function ProceedButton(element, events, options, module) {
    $(element).on("click", function() {
      events.trigger("proceedbutton:click");
    });
  };

  function CountdownTimer(element, events, options, module) {
    if( !module.options.countdown_timer ) {
      return;
    }

    if( mobile() ) {
      return;
    }

    events.on("popup:show", start);
    events.on("popup:hide", end);

    var end_event_name = "popup:proceed";
    if (module.options.countdown_timer_ends_on_event == "proceed") {
      end_event_name = "popup:proceed";
    } else if (module.options.countdown_timer_ends_on_event == "success") {
      end_event_name = "popup:success";
    }
    events.on(end_event_name, end);

    var timer;

    function start() {
      var milliseconds = module.options.countdown_timer;
      var seconds = milliseconds / 1000;

      $(element).html( format_seconds(seconds) );

      timer = setInterval(function() {
        $(element).html( format_seconds(seconds) );

        if( seconds == 0 ) {
          events.trigger("countdowntimer:end");
          end();
        }

        seconds--;
      }, 1000);
    };

    function end() {
      clearInterval(timer);
    };
  };

  function Form(element, events, options, module) {
    if (options.klaviyo_id) {
      klaviyo_load(function() {
        KlaviyoSubscribe.attachToForms(element, {
          success: function() {
            events.trigger("form:submit");
          }
        });
      });
    } else {
      // if we don't want to add the user to a list
      // (because we are just triggering a custom event to start a flow)
      $(element).on("submit", function(e) {
        e.preventDefault();
        events.trigger("form:submit");
      });
    }


    events.on("form:submit", function() {
      // TODO bind this to the form:submit event instead? But then Form wouldn't own it's own options. Maybe Step should anyway.
      if (options.redirect_enabled) {
        // TODO what about query params if a query param is also specified in theme settings?
        var current_url = window.location.origin + window.location.pathname;
        var redirect_url = options.redirect_url.replace("{{ current_url }}", current_url);

        window.setTimeout(function() {
          window.location.href = redirect_url;
        }, options.redirect_timer);
      }
    });

  };

  function Reminder(element, events, options, module) {
    if( !module.options.reminder ) {
      return;
    }

    var refs = {
      button: element.querySelectorAll("[data-ref-reminder-button]"),
      text: element.querySelectorAll("[data-ref-reminder-text]"),
      exit_button: element.querySelectorAll("[data-ref-reminder-exit-button]")
    };

    $(refs.button).on("click", function() {
      events.trigger("reminderbutton:click");
    });

    $(refs.exit_button).on("click", function() {
      events.trigger("reminderexitbutton:click");
    });

    events.on("reminderexitbutton:click", hide);
    events.on("popup:show", hide);
    events.on("popup:hidetransitionend", show);
    events.on("popup:hidetransitionend", show_text_temporarily);
    events.on("popup:success", disable);

    function show() {
      $(element).show();

      setTimeout(function() {
        $(element).addClass("is-active");
      });
    };

    function hide() {
      $(element)
        .hide()
        .removeClass("is-active");
    };

    function show_text_temporarily() {
      $(refs.text).addClass("is-active");

      setTimeout(function() {
        $(refs.text).removeClass("is-active");
      }, 2000);
    };

    function disable() {
      events.off("popup:hidetransitionend", show);
      events.off("popup:hidetransitionend", show_text_temporarily);
    };
  };

  function Popup(events, module) {
    events.on("exitintent", function() {
      events.trigger("popup:show");
    });

    events.on("reminderbutton:click", function() {
      events.trigger("popup:show");
    });

    events.on("stepbackground:click", function() {
      events.trigger("popup:hide");
    });

    events.on("exitbutton:click", function() {
      events.trigger("popup:hide");
    });

    events.on("exitkey:keyup", function() {
      events.trigger("popup:hide");
    });

    events.on("countdowntimer:end", function() {
      events.trigger("popup:hide");
    });

    events.on("proceedbutton:click", function() {
      events.trigger("popup:proceed");
    });

    events.on("form:submit", function() {
      events.trigger("popup:success");
    });
  };

  function ExitIntent(events, module) {
    if( module.options.aggressive ) {
      return events.trigger("exitintent");
    }

    if( mobile() ) {
      if( module.options.mobile_trigger == "exit-intent" ) {
        return scroll_up();
      } else {
        return timeout();
      }
    }

    if( module.options.trigger == "exit-intent" ) {
      return mouseleave();
    } else {
      return timeout();
    }

    function mouseleave() {
      $(document).on("mouseleave", function(e) {
        // have to check the mouse position here.
        // if you mouse over an iframe (like google maps address suggestions)
        // this will fire.
        if (e.clientY < 60) {
          events.trigger("exitintent");
          $(document).off('mouseleave');
        }
      });
    };

    function scroll_up() {
      var scroll_top = 0;

      $(window).on("scroll.exitintentpopup:scrollup", function(event) {
        var new_scroll_top = $(this).scrollTop();

        if( new_scroll_top - scroll_top < -30 ) {
          events.trigger("exitintent");
          $(window).off("scroll.exitintentpopup:scrollup");
        }

        scroll_top = new_scroll_top;
      });
    };

    function timeout() {
      var milliseconds = module.options.trigger_timer;

      if( mobile() ) {
        milliseconds = module.options.mobile_trigger_timer;
      }

      setTimeout(function() {
        events.trigger("exitintent");
      }, milliseconds);
    };
  };

  function ExitKey(events, module) {
    $(document).on("keyup.exitintentpopup:hide", function(event) {
       if( event.keyCode == 27 ) {
        events.trigger("exitkey:keyup");
        $(document).off("keyup.exitintentpopup:hide");
      }
    });
  };

  function PageView(events, module) {
    events.trigger("pageview");
  };

  function Url(events, module) {
    return {
      get disabled() {
        return module.options.disabled_urls.indexOf(window.location.pathname) > -1;
      },

      get referrer() {
        var document_referrer = document.referrer
          .replace(/^https?\:\/\//i, "")
          .replace(/[https*:\\]*www./, "")
          .replace(/\/$/, "");

        var referrer = module.options.referrer_urls.reduce(function(acc, url) {
          if( url == document_referrer ) {
            acc = true;
          }

          if( url.includes("/*") ) {
            if( document_referrer.includes(url.replace("/*", "")) ) {
              acc = true;
            }
          }

          return acc;
        }, false);

        return referrer;
      }
    }
  };

  function Customer(events, module) {
    var event_names = [
      "countdowntimer:end",
      "exitbutton:click",
      "exitintent",
      "exitkey:keyup",
      "form:submit",
      "pageview",
      "popup:hide",
      "popup:hidetransitionend",
      "popup:proceed",
      "popup:show",
      "popup:success",
      "proceedbutton:click",
      "reminderbutton:click",
      "reminderexitbutton:click"
    ];

    event_names.forEach(function(event_name) {
      set_initial_cookie(module.options.cookie_namespace + ":" + event_name);

      events.on(event_name, function() {
        if (debug) {
          console.log("event " + event_name + " fired");
        }
        update_cookie(module.options.cookie_namespace + ":" + event_name);
      });
    });

    if( module.options.disabled_days_count ) {
      events.on("popup:hide", function() {
        Cookies.set(module.options.cookie_namespace + ":popup:exitdisableddays", true, {
          expires: module.options.disabled_days_count
        });
      });
    }

    function set_initial_cookie(cookie_name) {
      if( Cookies.get(cookie_name ) ) {
        return;
      }

      Cookies.set(cookie_name, 0, { expires: 365 });
    };

    function update_cookie(cookie_name) {
      var value = Cookies.getJSON(cookie_name);
          value = parseInt(value || 0);

      Cookies.set(cookie_name, value + 1, { expires: 365 });
    };

    return {
      get do_not_show() {
        var url = Url(events, module);

        if( module.options.aggressive ) {
          return false;
        }

        return (
          (
            module.options.minimum_page_views_count &&
            Cookies.getJSON(module.options.cookie_namespace + ":pageview") < module.options.minimum_page_views_count
          ) ||
          (
            module.options.minimum_cart_items_count &&
            module.options.data.cart.item_count < module.options.minimum_cart_items_count
          ) ||
          (
            module.options.disabled_days_count &&
            Cookies.get(module.options.cookie_namespace + ":popup:exitdisableddays")
          ) ||
          (
            module.options.maximum_exit_count &&
            Cookies.getJSON(module.options.cookie_namespace + ":popup:hide") >= module.options.maximum_exit_count
          ) ||
          (
            module.options.countdown_timer_maximum_exit_count &&
            Cookies.getJSON(module.options.cookie_namespace + ":countdowntimer:end") >= module.options.countdown_timer_maximum_exit_count
          ) ||
          (
            module.options.disabled_urls.length &&
            url.disabled
          ) ||
          (
            module.options.referrer_urls.length &&
            !url.referrer
          ) ||
          Cookies.getJSON(module.options.cookie_namespace + ":popup:success") >= 1
        );
      },
      get reminder_closed() {
        return Cookies.getJSON(module.options.cookie_namespace +":reminderexitbutton:click");
      }
    };
  };

  function ExitIntentPopup(element, options) {
    var defaults = {};

    $.extend(options, defaults);

    var module = {
      element: element,
      options: options
    };

    var events = new EventEmitter();

    var customer = Customer(events, module);

    if( customer.do_not_show ) {
      options.enabled = false;
    }

    if( customer.reminder_closed ) {
      options.reminder = false;
    }

    if ( !options.enabled ) {
      return false;
    }

    // cart object is not available in checkout,
    // can't | json checkout object,
    // need to get creative
    if (typeof Checkout !== "undefined") {
      $.ajax({
        url: "/cart.js",
        method: "GET",
        dataType: "json",
        async: false,
        success: function (cart) {
          options.data.cart = cart;
        },
        error: function (xhr) {
          // TODO what to do?
          var error = JSON.parse(xhr.responseText);
          console.log(error);
        }
      });

      options.data.cart.checkout_url = window.location.origin + window.location.pathname;
    }

    if( customer.reminder_closed ) {
      options.reminder = false;
    }

    var refs = {
      steps: element.querySelectorAll("[data-ref-steps]"),
      step_1: element.querySelectorAll("[data-ref-step-1]"),
      step_2: element.querySelectorAll("[data-ref-step-2]"),
      step_3: element.querySelectorAll("[data-ref-step-3]"),
      banner: element.querySelectorAll("[data-ref-banner]"),
      exit_button: element.querySelectorAll("[data-ref-exit-button]"),
      proceed_button: element.querySelectorAll("[data-ref-proceed-button]"),
      countdown_timer: element.querySelectorAll("[data-ref-countdown-timer]"),
      form: element.querySelectorAll("[data-ref-form]"),
      reminder: element.querySelectorAll("[data-ref-reminder]"),
      input: element.querySelectorAll('[name="email"]')
    };

    refs.steps.forEach(function(element) {
      var options = element.getAttribute("data-ref-steps");
          options = JSON.parse(options || "{}");

      Steps(element, events, options, module);
    });

    refs.step_1.forEach(function(element) {
      var options = element.getAttribute("data-ref-step-1");
          options = JSON.parse(options || "{}");

      Step1(element, events, options, module);
    });

    refs.step_2.forEach(function(element) {
      var options = element.getAttribute("data-ref-step-2");
          options = JSON.parse(options || "{}");

      Step2(element, events, options, module);
    });

    refs.step_3.forEach(function(element) {
      var options = element.getAttribute("data-ref-step-3");
          options = JSON.parse(options || "{}");

      Step3(element, events, options, module);
    });

    refs.banner.forEach(function(element) {
      var options = element.getAttribute("data-ref-banner");
          options = JSON.parse(options || "{}");

      Banner(element, events, options, module);
    });

    refs.exit_button.forEach(function(element) {
      var options = element.getAttribute("data-ref-exit-button");
          options = JSON.parse(options || "{}");

      ExitButton(element, events, options, module);
    });

    refs.proceed_button.forEach(function(element) {
      var options = element.getAttribute("data-ref-proceed-button");
          options = JSON.parse(options || "{}");

      ProceedButton(element, events, options, module);
    });

    refs.countdown_timer.forEach(function(element) {
      var options = element.getAttribute("data-ref-countdown-timer");
          options = JSON.parse(options || "{}");

      CountdownTimer(element, events, options, module);
    });

    refs.form.forEach(function(element) {
      var options = element.getAttribute("data-ref-form");
          options = JSON.parse(options || "{}");

      Form(element, events, options, module);
    });

    refs.reminder.forEach(function(element) {
      var options = element.getAttribute("data-ref-reminder");
          options = JSON.parse(options || "{}");

      Reminder(element, events, options, module);
    });

    refs.input.forEach(function(element) {
      var options = JSON.parse(options || "{}");

      Input(element, events, options, module);
    });

    Klaviyo(events, module);

    Popup(events, module);

    ExitIntent(events, module);

    ExitKey(events, module);

    PageView(events, module);
  };

  var elements = document.querySelectorAll("[data-module-exit-intent-popup]");

  elements.forEach(function(element) {
    var options = element.getAttribute("data-module-exit-intent-popup");
        options = JSON.parse(options || "{}");

    ExitIntentPopup(element, options);
  });
})();
